export default "__VITE_ASSET__D37haodt__"